export const types = {
  SET_VIEWPORT: 'SET_VIEWPORT',
};

export const setViewport = viewport => ({
  type: types.SET_VIEWPORT,
  payload: viewport,
});

const initialState = null;

export default (state = initialState, { type, payload }) =>
  type === types.SET_VIEWPORT ? payload : state;

export const getViewport = state => state.mapViewport;



// WEBPACK FOOTER //
// ./src/reducers/mapViewport.js